/**
 * System Lizard - Live Oscilloscope & Chaotic Attractor Visualizer
 */

export class ScopeVisualizer {
  constructor(canvasElement, synthEngine) {
    this.canvas = canvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.synth = synthEngine;
    this.mode = 'oscilloscope'; // 'oscilloscope' or 'attractor'

    this.buffer = new Float32Array(1024);
    this.animId = null;

    this.resizeCanvas();
    window.addEventListener('resize', () => this.resizeCanvas());
  }

  resizeCanvas() {
    const rect = this.canvas.getBoundingClientRect();
    this.canvas.width = rect.width * (window.devicePixelRatio || 1);
    this.canvas.height = rect.height * (window.devicePixelRatio || 1);
  }

  setMode(mode) {
    this.mode = mode;
  }

  start() {
    const render = () => {
      this.draw();
      this.animId = requestAnimationFrame(render);
    };
    render();
  }

  stop() {
    if (this.animId) {
      cancelAnimationFrame(this.animId);
      this.animId = null;
    }
  }

  draw() {
    const w = this.canvas.width;
    const h = this.canvas.height;
    this.ctx.fillStyle = '#0a0d12';
    this.ctx.fillRect(0, 0, w, h);

    // Draw CRT Grid lines
    this.ctx.strokeStyle = 'rgba(0, 255, 170, 0.08)';
    this.ctx.lineWidth = 1;
    this.ctx.beginPath();
    for (let x = 0; x < w; x += w / 8) {
      this.ctx.moveTo(x, 0);
      this.ctx.lineTo(x, h);
    }
    for (let y = 0; y < h; y += h / 6) {
      this.ctx.moveTo(0, y);
      this.ctx.lineTo(w, y);
    }
    this.ctx.stroke();

    this.synth.getWaveformData(this.buffer);

    if (this.mode === 'oscilloscope') {
      this.drawOscilloscope(w, h);
    } else {
      this.drawAttractor(w, h);
    }
  }

  drawOscilloscope(w, h) {
    this.ctx.lineWidth = 2.5 * (window.devicePixelRatio || 1);
    this.ctx.strokeStyle = '#00ffaa';
    this.ctx.shadowBlur = 10;
    this.ctx.shadowColor = '#00ffaa';

    this.ctx.beginPath();
    const sliceWidth = w / this.buffer.length;
    let x = 0;

    for (let i = 0; i < this.buffer.length; i++) {
      const v = this.buffer[i];
      const y = (v * 0.45 + 0.5) * h;

      if (i === 0) {
        this.ctx.moveTo(x, y);
      } else {
        this.ctx.lineTo(x, y);
      }
      x += sliceWidth;
    }

    this.ctx.stroke();
    this.ctx.shadowBlur = 0;
  }

  drawAttractor(w, h) {
    this.ctx.lineWidth = 1.5 * (window.devicePixelRatio || 1);
    this.ctx.strokeStyle = '#ff007f';
    this.ctx.shadowBlur = 8;
    this.ctx.shadowColor = '#ff007f';

    this.ctx.beginPath();
    const halfLen = Math.floor(this.buffer.length / 2);

    for (let i = 0; i < halfLen; i++) {
      const xVal = this.buffer[i];
      const yVal = this.buffer[i + halfLen];

      const x = (xVal * 0.4 + 0.5) * w;
      const y = (yVal * 0.4 + 0.5) * h;

      if (i === 0) {
        this.ctx.moveTo(x, y);
      } else {
        this.ctx.lineTo(x, y);
      }
    }

    this.ctx.stroke();
    this.ctx.shadowBlur = 0;
  }
}
